import { ref, type Ref } from 'vue';
import type { IBattleplanMap } from '@scrolldex/shared';

function cloneMap(m: IBattleplanMap | null): IBattleplanMap {
  if (!m) return { objectives: [], terrain: [], zones: [] };
  return JSON.parse(JSON.stringify(m)) as IBattleplanMap;
}

export function useMapWorkingCopy(
  sourceMap: Readonly<Ref<IBattleplanMap | null>>,
  updateMap: (map: IBattleplanMap) => void,
) {
  const editMap = ref<IBattleplanMap>(cloneMap(sourceMap.value));

  function syncEditMapFromStore() {
    editMap.value = cloneMap(sourceMap.value);
  }

  function commit() {
    updateMap(JSON.parse(JSON.stringify(editMap.value)) as IBattleplanMap);
  }

  return { editMap, syncEditMapFromStore, commit };
}
